import { Injectable } from '@angular/core';
import { AuthConfig, LoginOptions, OAuthEvent, OAuthSuccessEvent, TokenResponse } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';

/**
 * DI seam for angular-oauth2-oidc's OAuthService, slimmed to the surface
 * this app uses. Bound to the real OAuthService in normal contexts and to
 * MockOAuthService in plugin/iframe contexts (see provideHypecastAuthentication).
 *
 * Extends AuthConfig for legacy reasons: consumers read/write config
 * properties (e.g. clientId, waitForTokenInMsec) directly on the service,
 * mirroring OAuthService itself.
 */
@Injectable()
export abstract class IOAuthService extends AuthConfig {
  constructor() {
    super();
  }
  /** Informs about events, like token_received or token_expires. */
  abstract events: Observable<OAuthEvent>;

  /** The received (passed around) state, when logging in with code flow. */
  abstract state?: string;

  abstract configure(config: AuthConfig): void;

  abstract loadDiscoveryDocument(fullUrl?: string): Promise<OAuthSuccessEvent | undefined>;

  abstract tryLogin(options?: LoginOptions): Promise<boolean>;

  abstract initCodeFlow(additionalState?: string, params?: object): void;

  abstract refreshToken(): Promise<TokenResponse | undefined>;

  abstract logOut(): void;
  abstract logOut(noRedirectToLogoutUrl: boolean): void;

  abstract getIdentityClaims(): Record<string, any> | undefined;

  abstract getIdToken(): string;

  abstract getAccessToken(): string;

  abstract getRefreshToken(): string;

  abstract getAccessTokenExpiration(): number;

  abstract getIdTokenExpiration(): number;

  abstract hasValidAccessToken(): boolean;

  abstract hasValidIdToken(): boolean;
}
